import { render } from "./blackNameList.vue?vue&type=template&id=5864b79c&scoped=true"
import script from "./blackNameList.vue?vue&type=script&lang=js"
export * from "./blackNameList.vue?vue&type=script&lang=js"

import "./blackNameList.vue?vue&type=style&index=0&id=5864b79c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5864b79c"

export default script